/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Archive_ConfirmInputs */

const en_lifecycle_archive_confirm = /** @type {(inputs: Lifecycle_Archive_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

const de_lifecycle_archive_confirm = /** @type {(inputs: Lifecycle_Archive_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivieren`)
};

/**
* | output |
* | --- |
* | "Archive" |
*
* @param {Lifecycle_Archive_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_archive_confirm = /** @type {((inputs?: Lifecycle_Archive_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Archive_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_archive_confirm(inputs)
	return en_lifecycle_archive_confirm(inputs)
});